<template>
    <div class="accordion-component">
        <div class="accordion-selectors" :class="selectorBackground">
            <div class="container">
                <div class="selector-container">
                    <div v-for="(item, index) in items" :key="index" class="item" @click="expand(index)" :class="{active : selectedIndex == index}">
                        <slot
                            name="accordion-selector-title"
                            :item="item"
                            :itemIndex="index"
                        />
                        <div class="dot"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="accordion-items">
            <div class="item" v-for="(item, index) in items" :key="index" :class="['background-'+index%3, {'even': index%2==0}, {'odd': index%2!=0}]" ref="listItems">
                <div class="header" @click="expand(index)">
                    <div class="container">
                        <div class="flex">
                            <div class="header-title">
                                <slot name="accordion-item-header-title" :item="item" :itemIndex="index" />
                            </div>
                            <div class="collapse-toggle">
                                <span class="btn expand">Expand <i class="fas fa-plus"></i></span>
                                <span class="btn collapse">Collapse <i class="fas fa-minus"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-content" ref="contentItems">
                    <div class="content-container">
                        <slot
                            name="accordion-item-content"
                            :item="item"
                            :itemIndex="index"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        selectorBackground: {
            type: String,
            default: 'bg-bright-blue'
        }
    },
    data() {
        return {
            selectedIndex: -1
        }
    },
    mounted() {
        // Add a resize listener to adjust the height of an open accordion on screen resize
        window.addEventListener('resize', this.windowSizeAdjusted);
    },
    destroyed() {
        // When this element is destroyed, remove the listener
        window.removeEventListener('resize', this.windowSizeAdjusted)
    },
    methods: {
        addItemRef(el) {
            this.itemRefs.push(el);
        },

        collapse: function(index) {
            this.selectedIndex = -1;
            
            this.$refs.contentItems[index].style.height = "0px";
            setTimeout(() => this.$refs.listItems[index].classList.remove('expanded'), 500);
        },

        expand: function(index) {
            // If this item is already expanded, collapse it
            if (this.selectedIndex == index) {
                this.collapse(index);
                return;
            }

            // If another item is already expanded, collapse it
            if (this.selectedIndex >= 0) {
                this.collapse(this.selectedIndex)
            }
            // Set the current index as the selecte item
            this.selectedIndex = index;

            // Set the height of this element
            this.setExpandedAccordionHeight(index);

            // Add class to parent list item
            this.$refs.listItems[index].classList.add('expanded'); // Make the element visible
        },
        getContentHeight(elem) {
            // Get the current height
            var origHeight = elem.style.height;
            // Show the element
            elem.style.display = 'block';
            // Set height to auto so the height can be determined
            elem.style.height = '';
            // Get the height of the element
            var height = elem.scrollHeight + 'px';
            // Return height to original size
            elem.style.height = origHeight;
            // Remove inline display property
            elem.style.display = '';
            return height;
        },

        setExpandedAccordionHeight(index) {
            if (this.selectedIndex >= 0) {
                // Get the current content element to expand
                let elem = this.$refs.contentItems[index];
                // Get the natural height of the element
                var height = this.getContentHeight(elem);
                // Update the height
                elem.style.height = height
            }
        },

        windowSizeAdjusted() {
            if (this.selectedIndex >= 0) {
                this.setExpandedAccordionHeight(this.selectedIndex);
            }
        }
    }
}
</script>